/** Apresentação única de situação e valores mensais do cancelamento. */
import { Badge } from '@/components/ui/badge';
import { StatusDot } from '@/components/tenant/SettingsInfoRow';
import { CANCEL_STATUS, type CancelGroupStatus } from '@/hooks/useStockChipCancellations';
import { formatCurrency } from '@/lib/currency-utils';

export const cancellationDate = (value: string | null | undefined) => value ? new Date(value.length === 10 ? `${value}T12:00:00` : value).toLocaleDateString('pt-BR') : '—';

/** Não transforma ausência de preço em custo zero. */
export function cancellationMoney(value: number, total: number, unpriced: number) {
  return total > 0 && unpriced >= total ? 'Sem valor informado' : formatCurrency(value ?? 0);
}

/** Selo de situação: sempre em linha única (o rótulo nunca quebra) e com a bolinha fixa. */
export function ChipCancellationStatus({ status }: { status: CancelGroupStatus }) {
  const s = CANCEL_STATUS[status];
  return <Badge variant="outline" className="h-5 shrink-0 gap-1.5 whitespace-nowrap px-1.5 text-[10px] font-medium"><StatusDot tone={s?.tone ?? 'muted'} className="shrink-0" />{s?.label ?? status}</Badge>;
}

/** Valores permanecem estimativas mensais, mesmo após a confirmação pelo broker. */
export function ChipCancellationSavings({ value, total, unpriced }: { value: number; total: number; unpriced: number }) {
  return <div className="min-w-0"><p className="break-words font-semibold text-success">{cancellationMoney(value, total, unpriced)}{total === 0 || unpriced < total ? <span className="text-xs font-normal">/mês</span> : null}</p>{unpriced > 0 && <p className="mt-1 text-xs text-muted-foreground">{unpriced} chip(s) sem referência · estimativa incompleta</p>}</div>;
}